import type { TalkRequest, TalkTurn } from '../../server-only/ai/onboarding';

export type {
  Decision,
  PlanItem,
  PlanKey,
  TalkDraft,
  TalkMessage,
  TalkTurn,
} from '../../server-only/ai/onboarding';

/** A turn can take a while: the model reads the whole conversation. */
const TIMEOUT_MS = 90_000;

/** `POST /ai/onboarding/turn` (`server-only/ai/onboarding.ts`). */
export const requestTalkTurn = async (
  body: TalkRequest,
  signal?: AbortSignal
): Promise<TalkTurn> => {
  const timeout = new AbortController();
  const timer = window.setTimeout(() => timeout.abort(), TIMEOUT_MS);
  const onAbort = () => timeout.abort();
  signal?.addEventListener('abort', onAbort);
  try {
    const response = await fetch('/ai/onboarding/turn', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(body),
      signal: timeout.signal,
    });
    const json = (await response.json().catch(() => null)) as
      | (TalkTurn & { detail?: string; error?: string })
      | null;
    if (!response.ok || !json) {
      throw new Error(json?.detail ?? json?.error ?? response.statusText);
    }
    return json;
  } finally {
    window.clearTimeout(timer);
    signal?.removeEventListener('abort', onAbort);
  }
};
